import Rank1 from "../svgs/rank_images_large/rank_1.svg";
import Rank2 from "../svgs/rank_images_large/rank_2.svg";
import Rank3 from "../svgs/rank_images_large/rank_3.svg";
import Rank4 from "../svgs/rank_images_large/rank_4.svg";
import Rank5 from "../svgs/rank_images_large/rank_5.svg";
import Rank6 from "../svgs/rank_images_large/rank_6.svg";
import Rank7 from "../svgs/rank_images_large/rank_7.svg";
import Rank8 from "../svgs/rank_images_large/rank_8.svg";
import Rank9 from "../svgs/rank_images_large/rank_9.svg";
import Rank10 from "../svgs/rank_images_large/rank_10.svg";
import Rank11 from "../svgs/rank_images_large/rank_11.svg";
import Rank12 from "../svgs/rank_images_large/rank_12.svg";
import Rank13 from "../svgs/rank_images_large/rank_13.svg";
import Rank14 from "../svgs/rank_images_large/rank_14.svg";
import Rank15 from "../svgs/rank_images_large/rank_15.svg";
import Rank16 from "../svgs/rank_images_large/rank_16.svg";
import Rank17 from "../svgs/rank_images_large/rank_17.svg";
import Rank18 from "../svgs/rank_images_large/rank_18.svg";
import Rank19 from "../svgs/rank_images_large/rank_19.svg";
import Rank20 from "../svgs/rank_images_large/rank_20.svg";
import styles from "@/styles/RankingPalette.module.scss";

const rankImages = {
  1: Rank1,
  2: Rank2,
  3: Rank3,
  4: Rank4,
  5: Rank5,
  6: Rank6,
  7: Rank7,
  8: Rank8,
  9: Rank9,
  10: Rank10,
  11: Rank11,
  12: Rank12,
  13: Rank13,
  14: Rank14,
  15: Rank15,
  16: Rank16,
  17: Rank17,
  18: Rank18,
  19: Rank19,
  20: Rank20,
};

const RankImage = ({ rank }) => {
  const RankComponent = rankImages[rank] || null;

  if (!RankComponent) {
    return null;
  }
  return <RankComponent className={styles.rankImage} />;
};

export default RankImage;
